<template>
  <tr class="even:bg-white odd:bg-gray-50">
    <td class="px-4 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
      <a role="button" class="underline" @click.prevent="showContact">
        {{ contact.fullName }}
      </a>
    </td>
    <td class="px-4 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
      {{ contact.jobPosition || '-' }}
    </td>
    <td class="px-4 py-4 whitespace-nowrap text-sm font-medium text-gray-900 tabular-nums" />
  </tr>
</template>

<script>
export default {
  props: {
    contact: {
      type: Object,
      required: true,
    },
  },
  methods: {
    showContact() {
      this.$modal.show({
        component: 'ContactModal',
        props: {
          contactId: this.contact.id,
        },
        on: {},
        hideEvent: 'hide',
      });
    },
  },
};
</script>
